/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardFeedbackContent } from './ScorecardFeedbackContent.js';
import {
    ScorecardFeedbackContentFromJSON,
    ScorecardFeedbackContentFromJSONTyped,
    ScorecardFeedbackContentToJSON,
} from './ScorecardFeedbackContent.js';

/**
 * 
 * @export
 * @interface ScorecardFeedback
 */
export interface ScorecardFeedback {
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedback
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedback
     */
    accountId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardFeedback
     */
    scorecardId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ScorecardFeedback
     */
    dateCreated?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScorecardFeedback
     */
    accountFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScorecardFeedback
     */
    accountLastName?: string;
    /**
     * 
     * @type {ScorecardFeedbackContent}
     * @memberof ScorecardFeedback
     */
    content?: ScorecardFeedbackContent;
}

/**
 * Check if a given object implements the ScorecardFeedback interface.
 */
export function instanceOfScorecardFeedback(value: object): boolean {
    return true;
}

export function ScorecardFeedbackFromJSON(json: any): ScorecardFeedback {
    return ScorecardFeedbackFromJSONTyped(json, false);
}

export function ScorecardFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardFeedback {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'scorecardId': json['scorecardId'] == null ? undefined : json['scorecardId'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'accountFirstName': json['accountFirstName'] == null ? undefined : json['accountFirstName'],
        'accountLastName': json['accountLastName'] == null ? undefined : json['accountLastName'],
        'content': json['content'] == null ? undefined : ScorecardFeedbackContentFromJSON(json['content']),
    };
}

export function ScorecardFeedbackToJSON(value?: ScorecardFeedback | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'accountId': value['accountId'],
        'scorecardId': value['scorecardId'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'accountFirstName': value['accountFirstName'],
        'accountLastName': value['accountLastName'],
        'content': ScorecardFeedbackContentToJSON(value['content']),
    };
}

